// ###### IMPORTS
import React, { useMemo } from 'react';

// ###### QUOTES
const KEY_MESSAGE_QUOTES = [
  { quote: 'A riqueza é a capacidade de experimentar a vida plenamente.', author: 'Henry David Thoreau' },
  { quote: 'O risco vem de não saber o que você está fazendo.', author: 'Warren Buffett' },
  { quote: 'Uma coisa barata que você não precisa é cara demais.', author: 'Benjamin Franklin' },
  { quote: 'Riqueza real é ter tempo e opções — não apenas dinheiro.', author: 'Morgan Housel' },
];

// ###### MAIN COMPONENT
const CardOverviewKeyMessage = () => {
  const selected = useMemo(() => {
    const dayOfYear = Math.floor((Date.now() - new Date(new Date().getFullYear(), 0, 0).getTime()) / 86400000);
    return KEY_MESSAGE_QUOTES[dayOfYear % KEY_MESSAGE_QUOTES.length];
  }, []);

  return (
    <div className="flex min-h-[48px] items-center justify-center overflow-hidden rounded-xl bg-gray-600 px-3 py-2 shadow md:min-h-[64px] md:px-4 md:py-3">
      <blockquote className="max-w-md text-center">
        <p className="text-sm font-medium italic leading-tight tracking-normal text-white md:text-lg md:leading-snug md:tracking-wide">
          "{selected.quote}"
        </p>
        <footer className="mt-1.5 text-xs font-normal text-white text-opacity-80 md:mt-2 md:text-sm">
          — {selected.author}
        </footer>
      </blockquote>
    </div>
  );
};

export default CardOverviewKeyMessage;
